import { Trans } from '@lingui/react/macro';

import Stack from '@/design_system/Stack';
import Paragraph from '@/design_system/Typography/Paragraph';

export const ServiceRefund = () => {
  return (
    <Stack gap="0.5rem">
      <p className="label-100-medium">
        <Trans id="article-services.service-refund.label">Services</Trans>
      </p>
      <Paragraph color="secondary">
        <Trans id="article-services.service-refund.text">
          No service is applicable. A refund has been proposed.
        </Trans>
      </Paragraph>
    </Stack>
  );
};
